import React from 'react';
import PropTypes from 'prop-types';
import css from './SpecialStatus.module.scss';
import classnames from 'classnames';

const SpecialStatus = ({ val }) => {
    return (
        <>
            {val.map((status, idx) => (
                <div style={{ backgroundColor: status.color }} className={classnames(css.orderStatus)} key={`status${idx}`}>
                    {status.name}
                </div>
            ))}
        </>
    );
};
SpecialStatus.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    styles: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.object)])
};
export default SpecialStatus;
